import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Categories from "./pages/Categories";
import TestConfig from "./pages/TestConfig";
import TestRun from "./pages/TestRun";
import Result from "./pages/Result";
import Stats from "./pages/Stats";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";
import Community from "./pages/Community";
import DailyChallenge from "./pages/DailyChallenge";
import Premium from "./pages/Premium";
import PremiumSuccess from "./pages/PremiumSuccess";
import Contact from "./pages/Contact";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminQuestions from "./pages/admin/AdminQuestions";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminImport from "./pages/admin/AdminImport";
import AdminContacts from "./pages/admin/AdminContacts";

import SupportChatWidget from "./components/SupportChatWidget";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

function AppShell() {
  const location = useLocation();
  const hideWidget = location.pathname.startsWith("/admin") || location.pathname.startsWith("/tests/run");
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/contacto" element={<Contact />} />

        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/tests" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
        <Route path="/tests/failed" element={<ProtectedRoute><TestConfig /></ProtectedRoute>} />
        <Route path="/tests/:categoryId" element={<ProtectedRoute><TestConfig /></ProtectedRoute>} />
        <Route path="/tests/run/:testId" element={<ProtectedRoute><TestRun /></ProtectedRoute>} />
        <Route path="/results/:resultId" element={<ProtectedRoute><Result /></ProtectedRoute>} />
        <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
        <Route path="/ranking" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/comunidad" element={<ProtectedRoute><Community /></ProtectedRoute>} />
        <Route path="/reto-diario" element={<ProtectedRoute><DailyChallenge /></ProtectedRoute>} />
        <Route path="/premium/success" element={<ProtectedRoute><PremiumSuccess /></ProtectedRoute>} />

        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<AdminOverview />} />
          <Route path="questions" element={<AdminQuestions />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="import" element={<AdminImport />} />
          <Route path="contactos" element={<AdminContacts />} />
        </Route>

        <Route path="*" element={<Landing />} />
      </Routes>
      {!hideWidget && <SupportChatWidget />}
    </>
  );
}

export default App;
